import { render, staticRenderFns } from "./ActionGiftInfo.vue?vue&type=template&id=2bb62839&"
import script from "./ActionGiftInfo.vue?vue&type=script&lang=js&"
export * from "./ActionGiftInfo.vue?vue&type=script&lang=js&"
import style0 from "./ActionGiftInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports